import { render, staticRenderFns } from "./PublicDashboardPage.vue?vue&type=template&id=f4595134&scoped=true"
import script from "./PublicDashboardPage.vue?vue&type=script&lang=js"
export * from "./PublicDashboardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4595134",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4595134')) {
      api.createRecord('f4595134', component.options)
    } else {
      api.reload('f4595134', component.options)
    }
    module.hot.accept("./PublicDashboardPage.vue?vue&type=template&id=f4595134&scoped=true", function () {
      api.rerender('f4595134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PublicDashboardPage.vue"
export default component.exports